/// <reference path="koyori.ts" />

/**
 * AJAX通信を行うコンポーネントです。
 * <dl>
 * <dt>属性</dt>
 * <dd>src: アクセス対象のURLを指定します</dd>
 * <dd>option: fetchのリクエストオプションを設定します（fetchメソッドのオプションと同様です）</dd>
 * <dd>enable: 設定することで通信を開始します（開始後は属性値の変更ごとに通信します）</dd>
 * </dl>
 * <dl>
 * <dt>イベント</dt>
 * <dd>fetch-approach: 通信前</dd>
 * <dd>fetch-success: 通信に成功した場合</dd>
 * <dd>fetch-ng: 通信に成功したが応答ステータスが異常な場合</dd>
 * <dd>fetch-error: 通信に失敗した場合</dd>
 * <dd>fetch-complete: 通信が完了した場合（成功もしくは失敗した後）</dd>
 * </dl>
 */
class KoyoriFetch extends KoyoriElement {

	/** フェッチ中の数 */
	static count = 0;

	static get observedAttributes() {
		return ['src', 'option', 'enable'];
	}

	/**
	 * AJAX通信を行います。fetch関数と違いCookieはデフォルトでは同一オリジンのみ送信します。
	 * 
	 * @param url
	 * @param option
	 * @param callback
	 * @param target
	 */
	static fetch(url: string, option: RequestInit = {}, callback: KoyoriFetchCallback = {}, target: HTMLElement = document.body) {
		if (option == null) {
			option = {};
		}
		if (option.credentials == undefined) {
			option.credentials = 'same-origin';
		}
		
		if (callback == null) {
			callback = {};
		}

		let result: boolean;
		if (callback.approach) {
			result = callback.approach();
			if (result == false) {
				return;
			}
		}
		result = KoyoriElement.fireEvent(target, 'fetch-approach', true, true);
		if (result == false) {
			return;
		}
		KoyoriFetch.count++;
		fetch(url, option).then(response => {
			KoyoriFetch.count--;
			if (response.ok == false) {
				result = true;
				if (callback.ng) {
					result = callback.ng(response);
				}
				if (result) {
					KoyoriElement.fireEvent(target, 'fetch-ng', true, true, {
						'response': response
					});
				}

				result = true;
				if (callback.complete) {
					result = callback.complete();
				}
				if (result) {
					KoyoriElement.fireEvent(target, 'fetch-complete', true, true);
				}

				return null;
			}

			result = true;
			if (callback.success) {
				result = callback.success(response);
			}
			if (result) {
				KoyoriElement.fireEvent(target, 'fetch-success', true, true, {
					'response': response
				});
			}
			
			result = true;
			if (callback.complete) {
				result = callback.complete();
			}
			if (result) {
				KoyoriElement.fireEvent(target, 'fetch-complete', true, true);
			}
		}).catch(error => {
			KoyoriFetch.count--;
			result = true;
			if (callback.error) {
				result = callback.error(null, error);
			}
			if (result) {
				KoyoriElement.fireEvent(target, 'fetch-error', true, true, {
					'error': error
				});
			}
			
			result = true;
			if (callback.complete) {
				result = callback.complete();
			}
			if (result) {
				KoyoriElement.fireEvent(target, 'fetch-complete', true, true);
			}
		});
	}

	srcChanged(): void {
		this.access();
	}

	optionChanged(): void {
		this.access();
	}

	enableChanged(value: string): void {
		if (value != null) {
			this.access();
		}
	}

	private access() {
		if (this.getAttribute('enable') == null) {
			return;
		}
		KoyoriFetch.fetch(this.getAttribute('src'), JSON.parse(this.getAttribute('request-option') || '{}'), null, this);
	}

}
window.customElements.define('koy-fetch', KoyoriFetch);

interface KoyoriFetchCallback {

	/** アクセスが開始する前に呼び出されます（falseを返すとリクエストが中断されます） */
	approach?: () => boolean;

	/** アクセスが成功した際に呼び出されます（falseを返すとイベントの発生が抑制されます） */
	success?: (response?: Response) => boolean;

	/** アクセスが成功したが応答ステータスが異常な場合に呼び出されます（falseを返すとイベントの発生が抑制されます） */
	ng?: (response?: Response) => boolean;

	/** エラーが発生した際に呼び出されます（falseを返すとイベントの発生が抑制されます） */
	error?: (response: Response, error: any) => boolean;

	/** 処理が終了した際によびだされます（falseを返すとイベントの発生が抑制されます） */
	complete?: () => boolean;
}